import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installApiAuth } from './utils/api';

// Before anything renders, so the very first API call of the session already
// carries the login token.
installApiAuth();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

